import VoiceSelectorModalBase from "@/components/modal/voice-selector/base/voice-selector-modal-base";
import TtsVoiceSelector from "@/components/common/voice-selector/selectors/tts-voice-selector";

const TtsVoiceSelectorModal = () => {
  return (
    <VoiceSelectorModalBase>
      <TtsVoiceSelector />
    </VoiceSelectorModalBase>
  );
};

export default TtsVoiceSelectorModal;
